// Port of api/fuel/app/classes/filter/search/games/rules/query/has_rated.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'has_rated',
	match: function(rule, config, filter, data, query) {
		query.where('r.user_id', 'in', data.users)

		if (rule.logic.value === 'yes') {
			query.exist('rating', 'r')
		} else if (rule.logic.value === 'no') {
			query.notexist('rating', 'r')
		}
	}
})
